import { RouteObject } from "react-router-dom";
import HomePage from "../pages/home/page";
import ManualPage from "../pages/manual/page";
import LoginPage from "../pages/auth/login";
import RegisterPage from "../pages/auth/register";
import ForgotPasswordPage from "../pages/auth/forgot-password";
import WorkbenchLayout from "../pages/workbench/layout";
import DashboardPage from "../pages/workbench/dashboard/page";
import AiChatPage from "../pages/workbench/ai-chat/page";
import ModelTrainingPage from "../pages/workbench/model-training/page";
import DocGenPage from "../pages/workbench/doc-gen/page";
import FilesPage from "../pages/workbench/files/page";
import FileDetailPage from "../pages/workbench/files/detail";
import ProjectsPage from "../pages/workbench/projects/page";
import ProjectDetailPage from "../pages/workbench/projects/detail";
import ContentSubPage from "../pages/workbench/content-sub/page";
import ContentReportsPage from "../pages/workbench/content-sub/reports/page";
import ContentReportDetailPage from "../pages/workbench/content-sub/reports/detail";
import UsersPage from "../pages/workbench/admin/users/page";
import RolesPage from "../pages/workbench/admin/roles/page";
import DepartmentsPage from "../pages/workbench/admin/departments/page";
import JobsPage from "../pages/workbench/admin/jobs/page";
import JobStagesPage from "../pages/workbench/admin/job-stages/page";
import MenusPage from "../pages/workbench/admin/menus/page";
import DataPermissionsPage from "../pages/workbench/admin/data-permissions/page";
import SystemSettingsPage from "../pages/workbench/admin/settings/page";
import NotFound from "../pages/NotFound";

const routes: RouteObject[] = [
  { path: "/", element: <HomePage /> },
  { path: "/manual", element: <ManualPage /> },
  { path: "/login", element: <LoginPage /> },
  { path: "/register", element: <RegisterPage /> },
  { path: "/forgot-password", element: <ForgotPasswordPage /> },
  {
    path: "/workbench",
    element: <WorkbenchLayout />,
    children: [
      { index: true, element: <DashboardPage /> },
      { path: "dashboard", element: <DashboardPage /> },
      { path: "ai-chat", element: <AiChatPage /> },
      { path: "model-training", element: <ModelTrainingPage /> },
      { path: "doc-gen", element: <DocGenPage /> },
      { path: "files", element: <FilesPage /> },
      { path: "files/:id", element: <FileDetailPage /> },
      { path: "projects", element: <ProjectsPage /> },
      { path: "projects/:id", element: <ProjectDetailPage /> },
      { path: "content-sub", element: <ContentSubPage /> },
      { path: "content-sub/reports", element: <ContentReportsPage /> },
      { path: "content-sub/reports/:id", element: <ContentReportDetailPage /> },
      { path: "admin/users", element: <UsersPage /> },
      { path: "admin/roles", element: <RolesPage /> },
      { path: "admin/departments", element: <DepartmentsPage /> },
      { path: "admin/jobs", element: <JobsPage /> },
      { path: "admin/job-stages", element: <JobStagesPage /> },
      { path: "admin/menus", element: <MenusPage /> },
      { path: "admin/data-permissions", element: <DataPermissionsPage /> },
      { path: "admin/settings", element: <SystemSettingsPage /> },
    ],
  },
  { path: "*", element: <NotFound /> },
];

export default routes;
